import React, { useState } from 'react';
import { FormGroup, Button, Row, Col } from 'reactstrap';
import * as Yup from 'yup';
import Helmet from 'react-helmet';
import { Link, useHistory } from 'react-router-dom';
import { Field, Form } from '@cordata/buffet';

import { baseInstance } from '~/utils';
import { Splash } from '~/components';

const submitForgot = credentials => baseInstance.post('/forgot-password', { ...credentials }).then(res => res.data);

const validationSchema = Yup.object().shape({
  username: Yup.string()
    .required(),
});

const initialValues = {
  username: '',
};

const ForgotForm = () => {
  const history = useHistory();
  const [loginMessage, setLoginMessage] = useState('We are unable to complete this action. Please contact your Cordata Support Representative');

  return (
    <Splash>
      <Helmet title="Forgot Password" />

      <Form
        displayName="ForgotForm"

        validationSchema={validationSchema}
        initialValues={initialValues}

        onSubmit={(values, { setErrors, setSubmitting }) => {
          const payload = {
            'user-name-or-email': values.username,
          };

          submitForgot(payload)
            .then(() => history.push('/login'))
            .catch((e) => {
              const msg = e.response.data.message;
              setErrors({ server: msg });

              if (msg.includes('not managed')) {
                setLoginMessage('Your account uses Microsoft to manage passwords. Please contact the administrator at your employer for assistance.');
              }
            })
            .then(() => setSubmitting(false));
        }}

        formAlertsProps={{
          loginMessage,
          login: true,
        }}
      >
        {({
          isSubmitting,
        }) => (
          <>
            <FormGroup>
              <Field
                name="username"
                placeholder="Enter your email / username"
                type="email"
                size="lg"
                label={false}
              />
            </FormGroup>

            <Row form>
              <Col xs="auto">
                <Button
                  disabled={isSubmitting}
                  outline
                  color="light"
                  block
                  tag={Link}
                  to="/login"
                >
                  Cancel
                </Button>
              </Col>

              <Col>
                <Button type="submit" disabled={isSubmitting} block>
                  {isSubmitting ? 'Requesting ...' : 'Request'}
                </Button>
              </Col>
            </Row>
          </>
        )}
      </Form>
    </Splash>
  );
};

export default ForgotForm;
